export default __webpack_public_path__ + "static/media/519.81b45853.png";